import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import HomePage from './pages/HomePage';
import ApartmentPage from './pages/ApartmentPage';
import BookingPage from './pages/BookingPage';
import BookingConfirmationPage from './pages/BookingConfirmationPage';
import BookingStatusPage from './pages/BookingStatusPage';
import GuestChat from './pages/GuestChat';
import AdminLoginPage from './pages/admin/AdminLoginPage';
import  AdminDashboard from './pages/admin/AdminDashboard';
import AdminBookings from './pages/admin/AdminBookings';
import AdminBookingDetail from './pages/admin/AdminBookingDetail';
import AdminApartments from './pages/admin/AdminApartments';
import AdminChat from './pages/admin/AdminChat';
import { useAdminAuth } from './hooks/useAdminAuth';

function ProtectedRoute({ children }) {
  const { isAuthenticated } = useAdminAuth();
  if (!isAuthenticated) return <Navigate to="/admin/login" replace />;
  return children;
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Guest-facing pages */}
        <Route path="/" element={<HomePage />} />
        <Route path="/apartment/:id" element={<ApartmentPage />} />
        <Route path="/book/:id" element={<BookingPage />} />
        <Route path="/booking-confirmed" element={<BookingConfirmationPage />} />
        <Route path="/booking/:ref" element={<BookingStatusPage />} />
        <Route path="/chat" element={<GuestChat />} />

        {/* Admin */}
        <Route path="/admin/login" element={<AdminLoginPage />} />
        <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
        <Route path="/admin/bookings" element={<ProtectedRoute><AdminBookings /></ProtectedRoute>} />
        <Route path="/admin/bookings/:id" element={<ProtectedRoute><AdminBookingDetail /></ProtectedRoute>} />
        <Route path="/admin/apartments" element={<ProtectedRoute><AdminApartments /></ProtectedRoute>} />
        <Route path="/admin/chat" element={<ProtectedRoute><AdminChat /></ProtectedRoute>} />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
